/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface MetierLocalisationSearch
 */
export interface MetierLocalisationSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof MetierLocalisationSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {number}
     * @memberof MetierLocalisationSearch
     */
    idmetier?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MetierLocalisationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof MetierLocalisationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof MetierLocalisationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MetierLocalisationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof MetierLocalisationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MetierLocalisationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the MetierLocalisationSearch interface.
 */
export function instanceOfMetierLocalisationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MetierLocalisationSearchFromJSON(json: any): MetierLocalisationSearch {
    return MetierLocalisationSearchFromJSONTyped(json, false);
}

export function MetierLocalisationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetierLocalisationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function MetierLocalisationSearchToJSON(value?: MetierLocalisationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'idmetier': value.idmetier,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

